import { useCallback } from 'react';

import { useLoyaltyServiceValidatePromotionCodeMutation } from 'generated/graphql-gateway';
import {
  PromoCodeError,
  PromoCodeErrorReason,
} from 'pages/loyalty/loyalty-offers/loyalty-promo-code/types';

const ERROR_REASON_MAP: Record<string, PromoCodeErrorReason | undefined> = {
  redeemedCode: PromoCodeErrorReason.redeemedCode,
  expiredCode: PromoCodeErrorReason.expiredCode,
  invalidCode: PromoCodeErrorReason.invalidCode,
};

export function useServicePromoCodeValidate() {
  const [validateMutation] = useLoyaltyServiceValidatePromotionCodeMutation();

  const validatePromoCode = useCallback(
    async (code: string): Promise<{ personalizedOfferId: string; configId: string }> => {
      const { data } = await validateMutation({
        variables: { input: { code, shouldRedeem: true } },
      });

      const result = data?.loyaltyServiceValidatePromotionCode;
      const personalizedOfferId = result?.personalizedOfferId;
      const configId = result?.configId;

      if (!personalizedOfferId || !configId) {
        const reason = result?.reason;
        const error = (reason && ERROR_REASON_MAP[reason]) || PromoCodeErrorReason.invalidCode;
        throw new PromoCodeError(error);
      }

      return { personalizedOfferId, configId };
    },
    [validateMutation]
  );

  return { validatePromoCode };
}
